var map = {
	"../../../pages/qr-code/qr-code.module.ngfactory": [
		"tc7m",
		8
	],
	"../../../pages/scan-qrcode/scan-qrcode.module.ngfactory": [
		"y9Di",
		48
	],
	"../../../pages/verify-table-code/verify-table-code.module.ngfactory": [
		"qgHt",
		57
	],
	"../brand-faq/brand-faq.module.ngfactory": [
		"0+al",
		50
	],
	"../brand-store-list/brand-store-list.module.ngfactory": [
		"+zm+",
		5,
		0,
		12
	],
	"../dinein-or-takeaway-page/dinein-or-takeaway-page.module.ngfactory": [
		"SQAv",
		55
	],
	"../item-grid-scroll/item-grid-scroll.module.ngfactory": [
		"otMd",
		2,
		4,
		0,
		15
	],
	"../item-grid/item-grid.module.ngfactory": [
		"AD3b",
		2,
		4,
		0,
		16
	],
	"../member-reward-new/member-reward-new.module.ngfactory": [
		"MDUx",
		0,
		44
	],
	"../member-reward/member-reward.module.ngfactory": [
		"Jx/8",
		0,
		13
	],
	"../modifier-item-select/modifier-item-select.module.ngfactory": [
		"LSuu",
		17
	],
	"../pages/category-group-list/category-group-list.module.ngfactory": [
		"L+vw",
		2,
		0,
		36
	],
	"../pages/category-item-list/category-item-list.module.ngfactory": [
		"G7ku",
		2,
		0,
		51
	],
	"../pages/category-list/category-list.module.ngfactory": [
		"7gFu",
		2,
		0,
		37
	],
	"../pages/item-grid-scroll/item-grid-scroll.module.ngfactory": [
		"otMd",
		2,
		4,
		0,
		15
	],
	"../pages/item-grid/item-grid.module.ngfactory": [
		"AD3b",
		2,
		4,
		0,
		16
	],
	"../pages/qr-code/qr-code.module.ngfactory": [
		"tc7m",
		8
	],
	"../pages/search-item/search-item.module.ngfactory": [
		"0iv1",
		2,
		0,
		56
	],
	"../pages/side-menu-category-list/side-menu-category-list-page.module.ngfactory": [
		"cko/",
		2,
		0,
		38
	],
	"./add-address/add-address.module.ngfactory": [
		"VPRx",
		73
	],
	"./alipay-payment/alipay-payment.module.ngfactory": [
		"YWD8",
		1,
		0,
		41
	],
	"./byod-summary/byod-summary.module.ngfactory": [
		"eF/a",
		3,
		0,
		18
	],
	"./cart/cart-scroll/cart-scroll.module.ngfactory": [
		"4Pq+",
		2,
		3,
		10,
		0,
		58
	],
	"./cart/cart.module.ngfactory": [
		"cYNU",
		2,
		3,
		10,
		0,
		59
	],
	"./cart/multi-order-cart/multi-order-cart.module.ngfactory": [
		"TEWH",
		2,
		3,
		5,
		0,
		11
	],
	"./credit-card-payment/credit-card-payment.module.ngfactory": [
		"Xeyw",
		1,
		0,
		60
	],
	"./delivery-login/delivery-login.module.ngfactory": [
		"vnGs",
		0,
		74
	],
	"./eft-payment/eft-payment.module.ngfactory": [
		"N8o6",
		1,
		0,
		61
	],
	"./login-court/login-court.module.ngfactory": [
		"Kao0",
		75
	],
	"./login/login.module.ngfactory": [
		"Q9+5",
		0,
		14
	],
	"./member-reward-court/member-reward-court.module.ngfactory": [
		"XFTW",
		76
	],
	"./member-reward/member-reward.module.ngfactory": [
		"Jx/8",
		0,
		13
	],
	"./mid-trans-payment/mid-trans-payment.module.ngfactory": [
		"RWAb",
		1,
		0,
		62
	],
	"./modifier-item-select/modifier-item-select.module.ngfactory": [
		"LSuu",
		17
	],
	"./mpgs-apple-pay-payment/mpgs-apple-pay-payment.module.ngfactory": [
		"z8L2",
		1,
		3,
		0,
		42
	],
	"./mpgs-credit-card-payment/mpgs-credit-card-payment.module.ngfactory": [
		"Lijj",
		1,
		0,
		63
	],
	"./mpgs-google-pay-payment/mpgs-google-pay-payment.module.ngfactory": [
		"sM2/",
		1,
		3,
		0,
		64
	],
	"./mpgs-host-session/mpgs-host-session.module.ngfactory": [
		"xbH0",
		1,
		0,
		65
	],
	"./multi-order-cart/multi-order-cart.module.ngfactory": [
		"TEWH",
		2,
		3,
		5,
		0,
		11
	],
	"./multi-order-detail/multi-order-detail.module.ngfactory": [
		"uh18",
		83
	],
	"./multi-order-history/multi-order-history.module.ngfactory": [
		"dKBQ",
		0,
		47
	],
	"./oepay-payment/oepay-payment.module.ngfactory": [
		"9qj0",
		1,
		3,
		0,
		43
	],
	"./openrice-payment/openrice-payment.module.ngfactory": [
		"SryB",
		0,
		35
	],
	"./order-detail/order-detail.module.ngfactory": [
		"JSSb",
		84
	],
	"./order-status/order-status.module.ngfactory": [
		"6Dmw",
		7,
		0,
		19
	],
	"./pages/brand-store-list/brand-store-list.module.ngfactory": [
		"+zm+",
		5,
		0,
		12
	],
	"./pages/byod-brand-splash/byod-brand-splash.module.ngfactory": [
		"8d1I",
		0,
		31
	],
	"./pages/byod-splash/byod-splash.module.ngfactory": [
		"gc8Q",
		7,
		0,
		32
	],
	"./pages/close/close.module.ngfactory": [
		"5pCk",
		52
	],
	"./pages/code/code-page.module.ngfactory": [
		"zSQ6",
		53
	],
	"./pages/delivery-information/delivery-information.module.ngfactory": [
		"WYxV",
		0,
		54
	],
	"./pages/store-list/store-list-page.module.ngfactory": [
		"NpZp",
		0,
		30
	],
	"./pages/test/test.module.ngfactory": [
		"Qy1k",
		0,
		46
	],
	"./pop-up-set-menu-withImg/pop-up-set-menu-withImg-page.module.ngfactory": [
		"IOuC",
		0,
		39
	],
	"./pop-up-set-menu/pop-up-set-menu.module.ngfactory": [
		"ouWR",
		0,
		40
	],
	"./profile-court/profile-court.module.ngfactory": [
		"s0ea",
		77
	],
	"./profile/profile.module.ngfactory": [
		"p6xJ",
		80
	],
	"./redirect-payment/redirect-payment.module.ngfactory": [
		"sJc6",
		1,
		0,
		66
	],
	"./registration-court/registration-court.module.ngfactory": [
		"dBu7",
		0,
		33
	],
	"./registration/registration.module.ngfactory": [
		"JWRA",
		0,
		34
	],
	"./reset-password-court/reset-password-court.module.ngfactory": [
		"ND6c",
		78
	],
	"./reset-password/reset-password.module.ngfactory": [
		"OIZK",
		81
	],
	"./reward-list/reward-list.module.ngfactory": [
		"Xwuq",
		0,
		45
	],
	"./routes/member/login/login.module.ngfactory": [
		"Q9+5",
		0,
		14
	],
	"./routes/summary/byod-summary/byod-summary.module.ngfactory": [
		"eF/a",
		3,
		0,
		18
	],
	"./routes/summary/order-status/order-status.module.ngfactory": [
		"6Dmw",
		7,
		0,
		19
	],
	"./saved-order-list/saved-order-list.module.ngfactory": [
		"QSay",
		86
	],
	"./set-sub-items/set-sub-items.module.ngfactory": [
		"UlqU",
		72
	],
	"./stripe-apple-payment/stripe-apple-payment.module.ngfactory": [
		"atIV",
		1,
		3,
		0,
		67
	],
	"./stripe-google-pay-payment/stripe-google-pay-payment.module.ngfactory": [
		"AXia",
		1,
		0,
		68
	],
	"./summary-list/summary-list.module.ngfactory": [
		"UMUz",
		0,
		87
	],
	"./summary/order-status-prekiosk/order-status-prekiosk.module.ngfactory": [
		"SHII",
		85
	],
	"./verify-registration-court/verify-registration-court.module.ngfactory": [
		"Ggab",
		0,
		79
	],
	"./verify-registration/verify-registration.module.ngfactory": [
		"JMPQ",
		0,
		82
	],
	"./wechat-open-payment/wechat-open-payment.module.ngfactory": [
		"xCDo",
		1,
		0,
		69
	],
	"./wechat-pay-payment/wechat-pay-payment.module.ngfactory": [
		"+iLe",
		1,
		0,
		70
	],
	"./wirecard-v2-payment/wirecard-v2-payment.module.ngfactory": [
		"TvEs",
		1,
		0,
		71
	],
	"src/app/dialogs/address-dialog/address-dialog.module.ngfactory": [
		"AV8P",
		49
	],
	"src/app/pages/qr-code/qr-code.module.ngfactory": [
		"tc7m",
		8
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "crnd";
module.exports = webpackAsyncContext;